import { CodegenConfig } from '@graphql-codegen/cli';

const endpointOverride = process.env.CONTENTFUL_GRAPHQL_ENDPOINT;
const contentfulEnvironmentSuffix = process.env.CONTENTFUL_ENVIRONMENT_ID
	? `/environments/${process.env.CONTENTFUL_ENVIRONMENT_ID}`
	: '';
const productionEndpoint = 'https://graphql.contentful.com/content/v1/spaces';
export const contentfulGraphQLURL = `${endpointOverride || productionEndpoint}/${
	process.env.CONTENTFUL_SPACE_ID
}${contentfulEnvironmentSuffix}`;

export const config: CodegenConfig = {
	overwrite: true,
	ignoreNoDocuments: true,
	schema: [
		{
			[contentfulGraphQLURL || '']: {
				headers: {
					Authorization: `Bearer ${process.env.CONTENTFUL_ACCESS_TOKEN}`,
				},
			},
		},
	],
	generates: {
		'src/lib/__generated/contentful/graphql.schema.json': {
			plugins: ['introspection'],
		},
		'src/lib/__generated/contentful/graphql.schema.graphql': {
			plugins: ['schema-ast'],
		},
		'src/lib/__generated/contentful/sdk.ts': {
			documents: ['src/lib/graphql/contentful/**/*.graphql'],
			plugins: [
				'typescript',
				'typescript-operations',
				'typescript-urql',
				{
					add: {
						content: `/* eslint-disable */
// @ts-nocheck`,
					},
				},
			],
			config: {
				rawRequest: false,
				inlineFragmentTypes: 'combine',
				skipTypename: false,
				exportFragmentSpreadSubTypes: true,
				dedupeFragments: true,
				preResolveTypes: true,
				scalars: {
					JSON: 'any',
				},
			},
		},
	},
};

export default config;
